type FullscreenDocument = Document & {
  webkitFullscreenElement?: Element | null;
  webkitExitFullscreen?: () => Promise<void> | void;
};
type FullscreenElement = HTMLElement & {
  webkitRequestFullscreen?: () => Promise<void> | void;
};

export const isFullScreen = (): boolean => {
  const doc = document as FullscreenDocument;
  return Boolean(doc.fullscreenElement || doc.webkitFullscreenElement);
};

export const openFullScreen = (): void => {
  if (isFullScreen()) return;

  const el = document.documentElement as FullscreenElement;
  // requestFullscreen is rejected unless called from an active user gesture
  // (transient activation). Swallow the rejection so we degrade gracefully
  // instead of throwing an unhandled promise rejection. Falls back to the
  // webkit-prefixed API for older Safari.
  try {
    if (el.requestFullscreen) {
      void Promise.resolve(el.requestFullscreen()).catch(() => {});
    } else if (el.webkitRequestFullscreen) {
      void Promise.resolve(el.webkitRequestFullscreen()).catch(() => {});
    }
  } catch {
    // unsupported / blocked — leave the window as-is
  }
};

export const exitFullScreen = (): void => {
  if (!isFullScreen()) return;

  const doc = document as FullscreenDocument;
  try {
    if (doc.exitFullscreen) {
      void Promise.resolve(doc.exitFullscreen()).catch(() => {});
    } else if (doc.webkitExitFullscreen) {
      void Promise.resolve(doc.webkitExitFullscreen()).catch(() => {});
    }
  } catch {
    // ignore
  }
};
